﻿@if (gridRows) {
  <div>
    <div class="ui-table-missing-scrollable-header"></div>
    <!-- Template for breadcrumb portal -->
    <ng-template #breadcrumbActions>
      <div class="grid-actions">
        @if (showColumnSelector && !useProductTypeColumnSelector && !useConfiguredColumnSelector) {
          <rdo-column-selector [size]="'md'"
            [gridConfig]="gridConfig" (visibilityChanged)="saveVisibility($event)"
            (downloadExcelClick)="downloadExcelClick.next(gridConfig)">
          </rdo-column-selector>
        }
        @if (showColumnSelector && useProductTypeColumnSelector) {
          <rdo-column-selector-product-type
            [size]="'md'" [gridConfig]="gridConfig" (visibilityChanged)="saveVisibility()"
            (downloadExcelClick)="downloadExcelClick.next(gridConfig)">
          </rdo-column-selector-product-type>
        }
        @if (showColumnSelector && useConfiguredColumnSelector) {
          <rdo-configured-column-selector
            [size]="'md'"
            [gridConfig]="columnSelectorConfig || gridConfig "
            (visibilityChanged)="saveVisibility()"
            (downloadExcelClick)="downloadExcelClick.next(gridConfig)"
            >
          </rdo-configured-column-selector>
        }
      </div>
    </ng-template>
    <p-table [value]="gridRows" [styleClass]="'rdo-ui-table'" [rowHover]="false" [sortMode]="'single'"
      [sortField]="sorting.sortField" [sortOrder]="sorting.sortOrder" [scrollable]="scrollable"
      [scrollHeight]="scrollHeight" [frozenValue]="frozenGridRows" [frozenWidth]="frozenWidth"
      [columns]="scrollableColumns" [frozenColumns]="frozenColumns" [customSort]="true" [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)" (onSort)="changeSort($event)" [style]="getDynamicTableStyle()">
      <ng-template pTemplate="colgroup" let-columns>
        @for (group of columns; track group) {
          @for (column of group.columns; track column) {
            <colgroup>
            <col [style.width]="getWidthStyle(column)" />
          </colgroup>
        }
      }
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (group of columns; track group) {
          <th [style.width]="getColGroupWidth(group)"
            [attr.colspan]="group.columns.length" [class.expandable]="group.expandable"
            [class.key-column]="isKeyColumn(group)" [class.group-end]="isGroupEnd(group)"
            id="{{group.title | rdoPathToId}}" class="groupHeader" [ngStyle]="group.headerStyle">
            <div data-toggle="tooltip" htmlTooltip="{{getGroupTooltip(group)}}"
              [attr.title]="getGroupTooltip(group) ? null : translate(group.title)">{{translate(group.title)}}
            </div>
            @if (group.forceCanClose !== false && (!group.locked || group.forceCanClose) && (group.text || group.columns.length > 1)) {
              <a
                (click)="toggleColumnVisibility(group)"
                title="{{'main.core.tables.common.hide_column_group' | translate}}">
                <span class="fa fa-lg fa-times-circle pull-right table-close-button"></span>
              </a>
            }
          </th>
        }
      </tr>
      <tr>
        @for (group of columns; track group) {
          @for (column of group.columns; track column; let columnIndex = $index) {
            <th id="{{column.sortColumn}}"
              [pSortableColumn]="filterSortableColumns(column)" [ngStyle]="column.headerStyle"
              [style.width.px]="ceil(column.width) || 110" [class.group-end]="isHeaderGroupEnd(group, column)"
              style="white-space:nowrap;" class="ellipsed-th">
              <div class="ellipsed-div">
                <!--[ngStyle]="{'line-height': (!group.text && group.columns.length == 1) || !allowDoubleHeader ? '2.9em' : 'unset' }"-->
                <div [ngStyle]="{'line-height': !allowDoubleHeader ? '2.9em' : 'unset' }"
                  [attr.data-column]="translate(column.title)"
                  [attr.title]="getColumnTooltip(column) ? null : translate(column.title)"
                     htmlTooltip="{{getColumnTooltip(column)}}">{{(column |
                rdoEllipsis:column.renderedWidth).processedTitle}}</div>
                <p-sortIcon [field]="column.sortColumn"></p-sortIcon>
                @if (group.forceCanClose !== false && (!group.locked || group.forceCanClose) && (!group.text && group.columns.length === 1)) {
                  <a
                    (click)="toggleColumnVisibility(group, column)"
                    title="{{'main.core.tables.common.hide_column_group' | translate}}">
                    <span class="fa fa-lg fa-times-circle pull-right table-close-button"></span>
                  </a>
                }
              </div>
            </th>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="frozenrows" let-rowData let-columns="columns" let-rowIndex="rowIndex">
      <tr class="frozen-row">
        @for (group of columns; track group) {
          @for (column of group.columns; track column; let i = $index) {
            <td id="header-{{column.sortColumn}}-cell"
              [ngClass]="rowData[column.sortColumn].class" [ngStyle]="rowData[column.sortColumn].style"
              [class.group-end]="isCellGroupEnd(group, column)"
              [class.transparent-text]="setTransparentText(group,columns)"
              [style.width]="rowData[column.sortColumn].width"
              title="{{handleValue(rowData[column.sortColumn].value)}}">
              @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && isBool(rowData[column.sortColumn].value) && rowData[column.sortColumn].value) {
                <i
                class="fa fa-check"></i>
              }
              @if (rowData[column.sortColumn].downloadFn) {
                <i
                  (click)="callDownloadFn(rowData[column.sortColumn].config, rowData.raw)"
                class="fa fa-download"></i>
              }
              @if (rowData[column.sortColumn].clickLinkFn) {
                <a
                (click)="callclickLinkFn(rowData[column.sortColumn].config, rowData.raw)">{{rowData[column.sortColumn].value}}</a>
              }
              @if (rowData[column.sortColumn].linkDsl) {
                <a
                  (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                [routerLink]="rowData[column.sortColumn].linkDsl">{{rowData[column.sortColumn].value}}</a>
              }
              @if (rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl) {
                <a
                  (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                href="{{rowData[column.sortColumn].href}}">{{rowData[column.sortColumn].value}}</a>
              }
              @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && !isBool(rowData[column.sortColumn].value) && !rowData[column.sortColumn].downloadFn && !rowData[column.sortColumn].clickLinkFn) {
                <span id="header-{{column.sortColumn}}-cell-text"
                >{{translate(rowData[column.sortColumn].value)}}</span>
              }
            </td>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
      <tr (mouseenter)="onMouseEnter(rowData)" (mouseleave)="onMouseLeave(rowData)"
        [class.row-hover]="rowData.hover">
        @for (group of columns; track group) {
          @for (column of group.columns; track column; let i = $index) {
            <td id="detail-{{column.sortColumn}}-{{rowIndex}}"
              [ngClass]="rowData[column.sortColumn].class"
              [ngStyle]="rowData[column.sortColumn].style" [style.width]="rowData[column.sortColumn].width"
              [class.group-end]="isCellGroupEnd(group, column)"
              title="{{handleValue(rowData[column.sortColumn].value)}}">
              @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && isBool(rowData[column.sortColumn].value) && rowData[column.sortColumn].value) {
                <i
                class="fa fa-check"></i>
              }
              @if (rowData[column.sortColumn].downloadFn) {
                <i style="cursor: pointer;"
                  (click)="callDownloadFn(rowData[column.sortColumn].config, rowData.raw)"
                class="fa fa-download"></i>
              }
              @if (rowData[column.sortColumn].clickLinkFn) {
                <a
                (click)="clickLinkFn(rowData[column.sortColumn].config, rowData.raw)">{{rowData[column.sortColumn].value}}</a>
              }
              @if (rowData[column.sortColumn].linkDsl) {
                <a
                  (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                [routerLink]="rowData[column.sortColumn].linkDsl">{{rowData[column.sortColumn].value}}</a>
              }
              @if (rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl) {
                <a
                  (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                href="{{rowData[column.sortColumn].href}}">{{rowData[column.sortColumn].value}}</a>
              }
              @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && !isBool(rowData[column.sortColumn].value) && !rowData[column.sortColumn].downloadFn && !rowData[column.sortColumn].clickLinkFn) {
                <span
                >{{translate(rowData[column.sortColumn].value)}}</span>
              }
            </td>
          }
        }
      </tr>
    </ng-template>
  </p-table>
  <p-paginator #gridPaginator id="gridPaginator"
    [styleClass]="(fixedScrollableHeight ? 'rdo-paginator rdo-head-paginator' : 'rdo-paginator') + ' ' + paginatorClass"
    [(first)]="paging.first" [rowsPerPageOptions]="[10,20,50]" [pageLinkSize]="10" [rows]="paging.pageSize"
    [totalRecords]="totalCount" (onPageChange)="onPage($event)" [alwaysShow]="alwaysShowPager">
  </p-paginator>
</div>
}
<div id="dummyDivForLength" #dummy style="padding: 3px 6px; position: absolute; left: -100px; top: -100px">
</div>
